import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BibleStudy } from '../api/models/BibleStudy';

type State = {
  list: BibleStudy[];
};

export const bibleStudySlice = createSlice({
  name: 'bibleStudy',
  initialState: {
    list: [],
  } as State,
  reducers: {
    receivedList: (state, action: PayloadAction<{ bibleStudies: BibleStudy[] }>) => {
      state.list = action.payload.bibleStudies;
    },
  },
});
